import { Header } from '@mairistem/composants';

import { ModalConfirm } from '@/components/Autre';

type ModalPosteComptableConfirmProps = {
  mode: 'add' | 'edit';
  onConfirm: () => void;
  onCancel: () => void;
};

const ModalPosteComptableConfirm = (props: ModalPosteComptableConfirmProps) => {
  const { mode, onConfirm, onCancel } = props;

  return (
    <ModalConfirm
      size={mode === 'add' ? 'small' : 'tiny'}
      content={
        mode === 'add' ? (
          <Header as="h4">
            <Header.Content>
              Êtes-vous sûr de vouloir ajouter un nouveau poste comptable ?
              <br />
              <br />
              <Header.Subheader>
                L&apos;ancien poste comptable sera rendu caduc et sera remplacé par le nouveau sur
                toutes les régies existantes.
              </Header.Subheader>
            </Header.Content>
          </Header>
        ) : (
          <Header as="h4">
            <Header.Content>
              Êtes-vous sûr de vouloir modifier ce poste comptable ?
              <br />
              <br />
              <Header.Subheader>
                Le poste comptable sera mis à jour sur toutes les régies existantes.
              </Header.Subheader>
            </Header.Content>
          </Header>
        )
      }
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  );
};

export default ModalPosteComptableConfirm;
